import React from "react";
import type {VoidFunctionComponent} from "react";
import {useSongDetailsLessonPreviewModalLogic} from "./SongDetailsLessonPreviewModal.logic";
import Modal from "../../../../../../components/common/Modal";
import ReactPlayer from "react-player";

export interface ISongDetailsLessonPreviewModalProps {
}

export const SongDetailsLessonPreviewModal: VoidFunctionComponent<ISongDetailsLessonPreviewModalProps> = ({}) => {
  const {isDisplayed, previewContent, closeModalHandler, previewWistiaVideoId, previewSheetMusicUrl} = useSongDetailsLessonPreviewModalLogic();
  if (!isDisplayed) {
    return null;
  }

  return (
    <Modal onClose={closeModalHandler} midiCloseShortcutNote={"B"} additionalClassName={`previewModal`}>

      {previewContent === "sheetMusic" ? (
        <img src={previewSheetMusicUrl} alt={`sheet music`}/>
      ): null}

      {previewContent === "video" ? (
        // Not using CSS Modules because ReactPlayer's custom class needs to exist within the wrapper
        <div className={'videoContainer'}>
          <ReactPlayer
            className='reactPlayer'
            url={`https://home.wistia.com/medias/${previewWistiaVideoId}`}
            width='100%'
            height='100%'
            playing={true}
            controls={true}
            config={{
              wistia: {
                options: {
                  fullscreenButton: true,
                  copyLinkAndThumbnailEnabled: false,
                  playerColor: '6b33ef',
                }
              }
            }}
          />
        </div>
      ): null}
    </Modal>
  );
}

